<template>
  <span class="flag" v-bind:class="getCountryClass(alpha2)" v-tooltip.bottom="tooltip"></span>
</template>
<script>
 export default {
  name: 'country-badge',
  props: {
    alpha2: {
      type: String,
      default: 'gb'
    },
    tooltip: {
      type: String,
      default: 'United Kingdom'
    }
  },
  methods: {
    getCountryClass(code) {
      return 'flag-' + code;
    }
  }
 }
</script>




// WEBPACK FOOTER //
// CountryBadge.vue?33eadc10